import axios from "axios";
import qs from "qs";
const initialState = {
	supportTicketMessage: {
		message_id: "",
		ticket_id: "",
		author_id: "",
		message:"",
		creation: "",
		message_html: ""
	},
	supportTicketMessages: [],
	supportTicketMessagesCount: 0
};

const state = { ...initialState };

const actions = {
	async loadTicketMessages(context, params) {
		return axios.get("/api/support/ticket/messages", {
			params: params
		}).then(function(response){
			
			context.commit("setSupportTicketMessages", response.data.supportTicketMessages);
			context.commit("setSupportTicketMessagesCount", response.data.supportTicketMessagesCount);
		})
	},

	async loadMoreTicketMessages(context, params) {
		return axios.get("/api/support/ticket/messages", {
			params: params
		}).then(function(response){
			
			context.commit("appendTicketMessages", response.data.supportTicketMessages);

		})
	},

	async sendTicketMessage(context, formData) {
		
		return axios.post("/api/support/ticket/message", formData).then(function(response){
			
			context.commit("addTicketMessage",response.data);
		})
	},

	resetMessages (context) {
		context.commit("clearTicketMessages");
	},
};

const mutations = {
	clearTicketMessages(state) {
		state.supportTicketMessages = [];
	},
	addTicketMessage(state, ticketMessage){
		state.supportTicketMessages.unshift(ticketMessage);
	},
	appendTicketMessages(state, ticketMessages){
		state.supportTicketMessages = state.supportTicketMessages.concat(ticketMessages);
	},
	setSupportTicketMessages(state,data) {
		state.supportTicketMessages = data;
	},
	setSupportTicketMessagesCount(state,data) {
		state.supportTicketMessagesCount = data;
	},
};

const getters = {
	supportTicketMessages(state){
		return state.supportTicketMessages;
	},
	supportTicketMessagesCount(state){
		return state.supportTicketMessagesCount;
	},
};

export default {
    state,
    actions,
    mutations,
    getters
};
  